"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSettings = void 0;
const timeZones_1 = __importDefault(require("../../common/timeZones"));
const PtoConfig_1 = require("../../pto/model/PtoConfig");
const branchSettings_1 = require("./branchSettings");
class GroupSettings extends branchSettings_1.BranchSettings {
    groupSettings;
    integrationSettings;
    ptoConfig = new PtoConfig_1.PtoConfig({ groupId: 0 });
    selectedOem = 0;
    useMFA = false;
    constructor(param) {
        super({ timeZone: timeZones_1.default.ASIA_TOKYO });
        if (param?.ptoConfig) {
            this.ptoConfig = param.ptoConfig;
        }
        if (param?.selectedOem !== undefined) {
            this.selectedOem = param.selectedOem;
        }
        if (param?.useMFA !== undefined) {
            this.useMFA = param.useMFA;
        }
        if (param?.integrationSettings) {
            this.integrationSettings = param.integrationSettings;
        }
    }
    setGroupSettings(settings) {
        this.groupSettings = settings;
    }
    getPtoConfig() {
        return this.ptoConfig;
    }
    getSelectedOem() {
        return this.selectedOem;
    }
    setSelectedOem(selectedOem) {
        this.selectedOem = selectedOem;
    }
    getUseMFA() {
        return this.useMFA;
    }
    setUseMFA(useMFA) {
        this.useMFA = useMFA;
    }
    getIntegrationSettings() {
        return this.integrationSettings;
    }
}
exports.GroupSettings = GroupSettings;
